<template>
  <span class="loading" v-if="is_loading">読み込み中<span></span></span>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      is_loading: {
        type: Boolean,
        default: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  span.loading {
    display: inline-block;
    white-space: nowrap;
    transition: all 1s ease-in-out;
  }

  span.loading span {
    display: inline-block;
    width: 100px;
    height: 2px;
    vertical-align: middle;

    background-position: 0 0;
    background-repeat: repeat-x;
    background-size: 4px 100%;

    background-image: -webkit-gradient(linear, left top, right top, from(transparent), color-stop(0.5, transparent), color-stop(0.5, #000), to(#000));
    background-image: -webkit-linear-gradient(left, transparent 2px, #000 4px);
    background-image: linear-gradient(to right, transparent 2px, #000 4px);

    -webkit-animation: animation 1.5s linear infinite;
    animation: animation 1.5s linear infinite;
  }

  @-webkit-keyframes animation {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  @keyframes animation {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }
</style>

